<template>
  <!-- 各参建院校建设进度 -->
  <div class="page">
    <div :style="{filter: this.$store.state.isVague?'blur(2px)':''}">
      <div class="table-search-box">
        <el-form :inline="true" :model="formResourceBase" class="demo-form-inline">
          <el-form-item label="参建单位名称：">
            <el-select size="small" v-model="formResourceBase.name" placeholder="切换参建院校名称" :popper-append-to-body="false" @change="switchItems">
              <el-option v-for="(item,index) in this.regionList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <!-- 第一层 -->
      <el-row :gutter="12" class="sameLayer beltLegend">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>学生用户建设情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'studentUsersChart'" :datas='studentUsers.dataList' :transverseData='studentUsers.transverseData' :colorList='studentUsers.colorList' :legendList='studentUsers.legendList' :innerText="'单位：人'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>学生用户建设质量</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'studentQualityChart'" :datas='studentQuality.dataList' :transverseData='studentQuality.transverseData' :colorList='studentQuality.colorList' :legendList='studentQuality.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师用户建设情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'teachersUsersChart'" :datas='teachersUsers.dataList' :transverseData='teachersUsers.transverseData' :colorList='teachersUsers.colorList' :legendList='teachersUsers.legendList' :innerText="'单位：人'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第二层 -->
      <el-row :gutter="12" class="sameLayer">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师用户建设质量</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'tsNoActivityChart'" :datas='tsNoActivity.dataList' :transverseData='tsNoActivity.transverseData' :colorList='tsNoActivity.colorList' :legendList='tsNoActivity.legendList' :innerText="'单位：%'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>资源建设情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <vcolumnarChart :refId="'resourceConstructionChart'" :datas='resourceConstruction.dataList' :transverseData='resourceConstruction.transverseData' :colorList='resourceConstruction.colorList' :legendList='resourceConstruction.legendList' :innerText="'单位：个'"></vcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>教师课程建设情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits1.tableList' :headerData='resourceVisits1.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits1.tableList.length >= 6" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits2.url,'教师课程建设情况(前100名)',resourceVisits1.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 第三层 -->
      <el-row :gutter="12" class="sameLayer" type="flex" style="margin-bottom:0px;">
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>参建院校教师专业分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'teacherCollegesChart'" :datas='teacherColleges.dataList' :transverseData='teacherColleges.transverseData' :colorList='teacherColleges.colorList' :innerText="'单位：人数'"></tcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>参建院校学生专业分布</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'studentCollegesChart'" :datas='studentColleges.dataList' :transverseData='studentColleges.transverseData' :colorList='studentColleges.colorList' :innerText="'单位：人数'"></tcolumnarChart>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="generalBg_Virtualization"></div>
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span>学生选课情况</span>
              </div>
              <i class="threePoints el-icon-more"></i>
            </div>
            <div class="standards_content">
              <div style="padding:15px;padding-bottom:0px;">
                <tableList :tableData='resourceVisits2.tableList' :headerData='resourceVisits2.headerList'></tableList>
                <div class="viewMore">
                  <el-button v-if="resourceVisits2.tableList.length >= 6" size="small" class="upAndDown" style="margin-left:0px;" @click="seeMore(resourceVisits1.url,'学生选课情况(前100名)',resourceVisits2.headerList)">查看更多</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-backtop :bottom="80" target=".page" class="backtops"></el-backtop>
    </div>

    <!-- 表格中查看更多 -->
    <el-dialog :title="detailsBox.title" :visible.sync="detailsBox.show" :close-on-click-modal="false" width="600px" class="pop_up distribute" append-to-body :before-close="handleClose">
      <div class="moreBox">
        <tableList :tableData='detailsBox.data.tableList' :headerData='detailsBox.data.headerList'></tableList>
      </div>
      <div class="tx-center">
        <el-button size="small" @click="handleClose">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 加载组件 -->
    <loading class="loading_box" v-if="this.$store.state.loading"></loading>
  </div>
</template>


<script>
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue' //引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue' //引入横向柱状图图表
import discountChart from '@/components/chart/discountChart.vue' //引入折线图图表
import tableList from '@/components/tableList.vue' //表格


export default {
  components: {
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    tableList
  },
  data() {
    return {
      colorList: ['#1BF6F8', '#3B86FF', '#FA4798', '#6FE05F', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],  //柱状图或折线图的颜色

      formResourceBase: {
        name: ''
      },
      regionList: [{
        name: '订单',
        value: '1'
      }],

      // 第一层
      studentUsers: {  //学生用户建设情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      studentQuality: { //学生用户建设质量
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      teachersUsers: {  //教师用户建设情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },


      // 第二层
      tsNoActivity: {  // 教师用户建设质量
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      resourceConstruction: { // 资源建设情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: []
      },
      resourceVisits1: {
        tableList: [],
        headerList: [],
        url: ''
      },


      // 第三层
      teacherColleges: { //参建院校教师专业分布
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      studentColleges: { //参建院校学生专业分布
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      resourceVisits2: {
        tableList: [],
        headerList: [],
        url: ''
      },

      // 表格弹窗
      detailsBox: {
        title: '',
        show: false,
        data: {
          tableList: [],
          headerList: []
        }
      }


      //// 第四层
      // oneYearRecent: {   //近一年各模块应用情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },


      // // 第五层
      // oneVisits: {   //近一个月师生访问情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },


      // // 第六层
      // threeVisits: {   //近三个月师生访问情况
      //   dataList: [],
      //   transverseData: [],
      //   colorList: [],
      //   legendList: []
      // },
    }
  },
  created() {
    this.subproject()
    this.resourceVisits1.url = this.$apiurls.getUnitStudentSeletionCourseList
    this.resourceVisits2.url = this.$apiurls.getTeacherCourseBuildList
  },
  methods: {
    // 获取子项目数据
    subproject() {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionPlanList, {
        name: "",
        pageDto: {
          pageNum: 1,
          pageSize: 9999
        },
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.regionList = res.data.list
          this.formResourceBase.name = res.data.list[0]
          // 第一层
          this.studentUsersDom(res.data.list[0])
          this.studentQualityDom(res.data.list[0])
          this.teachersUsersDom(res.data.list[0])

          // 第二层
          this.tsNoActivityDom(res.data.list[0])
          this.resourceConstructionDom(res.data.list[0])
          this.resourceVisits1Dom(res.data.list[0])


          // 第三层
          this.teacherCollegesDom(res.data.list[0])
          this.studentCollegesDom(res.data.list[0])
          this.resourceVisits2Dom(res.data.list[0])



          //// 第四层
          // this.oneYearRecentDom(res.data.list[0])

          // // 第五层
          // this.oneVisitsDom(res.data.list[0])

          // // 第六层
          // this.threeVisitsDom(res.data.list[0])
        }
      });
    },

    // 切换项目
    switchItems() {
      // 第一层
      this.studentUsersDom()
      this.studentQualityDom()
      this.teachersUsersDom()


      // 第二层
      this.tsNoActivityDom()
      this.resourceConstructionDom()
      this.resourceVisits1Dom()



      // 第三层
      this.teacherCollegesDom()
      this.studentCollegesDom()
      this.resourceVisits2Dom()





      //// 第四层
      // this.oneYearRecentDom()

      // // 第五层
      // this.oneVisitsDom()

      // // 第六层
      // this.threeVisitsDom()
    },
    // 第一层
    // 学生用户建设情况
    studentUsersDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 1,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.studentUsers.dataList = [realValue, targetValue]
          this.studentUsers.transverseData = nameList
          this.studentUsers.colorList = this.colorList
          this.studentUsers.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 学生用户建设质量
    studentQualityDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 2,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.studentQuality.dataList = [realValue, targetValue]
          this.studentQuality.transverseData = nameList
          this.studentQuality.colorList = this.colorList
          this.studentQuality.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 教师用户建设情况
    teachersUsersDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 3,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.teachersUsers.dataList = [realValue, targetValue]
          this.teachersUsers.transverseData = nameList
          this.teachersUsers.colorList = this.colorList
          this.teachersUsers.legendList = ['监测平台值', '任务目标值']
        }
      });
    },


    // 第二层
    // 教师用户建设质量
    tsNoActivityDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 4,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.tsNoActivity.dataList = [realValue, targetValue]
          this.tsNoActivity.transverseData = nameList
          this.tsNoActivity.colorList = this.colorList
          this.tsNoActivity.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 资源建设情况
    resourceConstructionDom(name) {
      this.$axios.post(this.$apiurls.getConstructionProgressOfParticipatingInstitutionEcharts, {
        echartsType: 5,
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          var realValue = []
          var targetValue = []
          var nameList = []
          for (let i = 0; i < res.data.length; i++) {
            if (!res.data[i].value) {
              res.data[i].value = {}
              res.data[i].value.realValue = 0
              res.data[i].value.targetValue = 0
            } else {
              if (!res.data[i].value.realValue) {
                res.data[i].value.realValue = 0
              }
              if (!res.data[i].value.targetValue) {
                res.data[i].value.targetValue = 0
              }
            }
            realValue.push(res.data[i].value.realValue)
            targetValue.push(res.data[i].value.targetValue)
            nameList.push(res.data[i].name)
          }
          this.resourceConstruction.dataList = [realValue, targetValue]
          this.resourceConstruction.transverseData = nameList
          this.resourceConstruction.colorList = this.colorList
          this.resourceConstruction.legendList = ['监测平台值', '任务目标值']
        }
      });
    },
    // 教师课程建设情况
    resourceVisits1Dom(name) {
      if (!name) {
        name = '""'
      }
      this.$axios.post(this.$apiurls.getTeacherCourseBuildList, {
        limitNum: "7",
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data.length >= 7) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits1.tableList = res.data
          this.resourceVisits1.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '课程名称',
            prop: 'name'
          }, {
            name: '访问量',
            prop: 'num'
          }, {
            name: '选课人数',
            prop: 'count'
          }]
        }
      });
    },


    // 第三层
    // 参建院校教师专业分布
    teacherCollegesDom(name) {
      if (!name) {
        name = '""'
      }
      this.$axios.post(this.$apiurls.getTeacherStudentProfessionDistribute, {
        schoolName: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 2
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.teacherColleges.dataList = res.data.value
          this.teacherColleges.transverseData = res.data.name
          this.teacherColleges.colorList = this.colorList
        }
      });
    },
    // 参建院校学生专业分布
    studentCollegesDom(name) {
      this.$axios.post(this.$apiurls.getTeacherStudentProfessionDistribute, {
        schoolName: this.formResourceBase.name ? this.formResourceBase.name : name,
        type: 1
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.studentColleges.dataList = res.data.value
          this.studentColleges.transverseData = res.data.name
          this.studentColleges.colorList = this.colorList
        }
      });
    },
    // 学生选课情况
    resourceVisits2Dom(name) {
      if (!name) {
        name = '""'
      }
      this.$axios.post(this.$apiurls.getUnitStudentSeletionCourseList, {
        limitNum: "7",
        name: this.formResourceBase.name ? this.formResourceBase.name : name,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          console.log(res);
          if (res.data.length >= 7) {
            res.data.splice(res.data.length - 1, 1)
          }
          this.resourceVisits2.tableList = res.data
          this.resourceVisits2.headerList = [{
            name: '序号',
            prop: 'index'
          }, {
            name: '学生名称',
            prop: 'name'
          }, {
            name: '访问量',
            prop: 'num'
          }, {
            name: '学习课程数',
            prop: 'count'
          }]
        }
      });
    },

    // 查看更多
    seeMore(url, title, headerList) {
      this.$store.commit('isLoading', true);
      this.detailsBox.data.tableList = []
      this.$axios.post(url, {
        limitNum: "100",
        name: this.formResourceBase.name
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.$message({
            message: '查询成功！',
            type: 'success'
          });
          this.detailsBox.data.tableList = res.data
          this.detailsBox.data.headerList = headerList
          this.detailsBox.show = true
          this.detailsBox.title = title
          this.$store.commit('modifyVague', true);
          this.$store.commit('isLoading', false);
        }
      }).catch(_ => {
        this.$store.commit('isLoading', false);
      });
    },
    // 关闭弹窗
    handleClose() {
      this.detailsBox.show = false
      this.$store.commit('modifyVague', false);
      this.$store.commit('isLoading', false);
    },







    // // 第四层
    // // 近一年各模块应用情况
    // oneYearRecentDom() {
    //   this.oneYearRecent.dataList = [50, 80, 90, 450, 80, 90]
    //   this.oneYearRecent.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.oneYearRecent.colorList = this.colorList
    //   this.oneYearRecent.legendList = ['数据1']
    // },

    // // 第五层
    // // 近一个月师生访问情况
    // oneVisitsDom() {
    //   this.oneVisits.dataList = [50, 80, 90, 450, 80, 90]
    //   this.oneVisits.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.oneVisits.colorList = this.colorList
    //   this.oneVisits.legendList = ['数据1']
    // },

    // // 第六层
    // // 近三个月师生访问情况
    // threeVisitsDom() {
    //   this.threeVisits.dataList = [50, 80, 90, 450, 80, 90]
    //   this.threeVisits.transverseData = [2019, 2020, 2021, 2022, 2023, 2024]
    //   this.threeVisits.colorList = this.colorList
    //   this.threeVisits.legendList = ['数据1']
    // },
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/table.scss" scoped></style>
<style  lang="scss" scoped>
// 图表
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: calc(100% - 40px);
}

// 带legend
.beltLegend .el-col {
  height: 420px;
}

.moreBox {
  height: 550px;
  overflow-y: auto;
}
.tx-center {
  margin-top: 10px;
}
</style>
